import { useTranslation } from 'react-i18next';
import { SPORT_TYPES } from '../constants/sportTypes';

type SportType = (typeof SPORT_TYPES)[number];

export function useSportTypeLabel() {
    const { t } = useTranslation();
    // Accepts a plain string, not just SportType, since callers often pass
    // API response data (e.g. race.SPORT_TYPE) that isn't compile-time
    // narrowed to the union even though it's validated server-side. The cast
    // is safe because the sportTypes.* keys exactly match SPORT_TYPES, and
    // defaultValue covers any runtime value that doesn't have a translation.
    return (type: string) => t(`sportTypes.${type}` as `sportTypes.${SportType}`, { defaultValue: type });
}
